// longitude = d'est en ouest
// latitude = du nord au sud

const placesContainer = document.getElementById("mm-map-places");
if (placesContainer) {
	const placeCardTemplate = document.getElementById("mm-map-place-template");

	const placesJSONEl = document.querySelector("#mm-places-json .metafield-json");
	const mapboxTokenInput = document.getElementById("mm-mapbox-token");
	const geocoderWrapper = document.querySelector(".mm-places-wrapper #mm-map-geocoder");

	const PLACE_SELECTED_CLASS = "selected";
	const MARKER_DEFAULT_COLOR = "#021208";
	const MARKER_SELECTED_COLOR = "#FF0000";

	mapboxgl.accessToken = mapboxTokenInput.value;
	const places = JSON.parse(placesJSONEl.innerText).map((placeData) => {
		return {
			name: placeData.name,
			address: placeData.address,
			country: placeData.country,
			url: placeData.url,
			coordinates: [placeData.Longitude, placeData.Latitude],
		};
	});

	function mmDisplayVisibleMarkers(map) {
		// same with destructuring:
		const {
			_ne: { lng: maxEast, lat: maxNorth },
			_sw: { lng: maxWest, lat: maxSouth },
		} = map.getBounds();

		// Clear all country containers first
		placesContainer.innerHTML = "";

		// Create a map to group places by country
		const placesByCountry = {};

		places.forEach((place) => {
			const [lng, lat] = place.coordinates;

			const visible = lng < maxEast && lng > maxWest && lat > maxSouth && lat < maxNorth;

			if (visible) {
				// Group places by country
				if (!placesByCountry[place.country]) {
					placesByCountry[place.country] = [];
				}
				placesByCountry[place.country].push(place);
			}
		});

		// Now insert all places by country
		Object.keys(placesByCountry).forEach((country) => {
			// Create country container
			const countryContainer = document.createElement("div");
			// Convertir le nom du pays en un identifiant CSS valide (remplacer espaces et virgules par des tirets)
			const countryClass = country.replace(/[ ,]+/g, "-");
			countryContainer.classList.add(`mm-cards-container-${countryClass}`);
			const containerTitle = `<p class="">${country}</p>`;
			countryContainer.insertAdjacentHTML("afterBegin", containerTitle);
			placesContainer.appendChild(countryContainer);

			// Add all places for this country
			placesByCountry[country].forEach((place) => {
				const card = placeCardTemplate.content.cloneNode(true).firstElementChild;
				const nameEl = card.querySelector("[data-place-name]");
				nameEl.textContent = place.name;

				// Création de la balise <a> pour l'URL
				const urlEl = card.querySelector("[data-place-url]");
				const linkEl = document.createElement("a");
				linkEl.href = place.url;
				linkEl.textContent = "Voir le site web";
				urlEl.innerHTML = "";
				urlEl.appendChild(linkEl);

				card.dataset.placeCoordinates = JSON.stringify(place.coordinates);
				countryContainer.appendChild(card);
			});
		});
	}

	function mmFlyToPlaceByCoordinates(coordinates) {
		const map = window.mmMap;
		map.flyTo({ center: coordinates, zoom: 15 }, { placeCoordinatesToSelect: coordinates });
	}

	function mmSelectPlaceByCoordinates(coordinates) {
		// Sélectionner toutes les cartes, indépendamment de leur conteneur parent
		const allCards = placesContainer.querySelectorAll(".mm-map-place-card");

		allCards.forEach((card) => {
			card.classList.remove(PLACE_SELECTED_CLASS);

			const [cardLng, cardLat] = JSON.parse(card.dataset.placeCoordinates);
			const [lng, lat] = coordinates;
			if (cardLng === lng && cardLat === lat) {
				card.classList.add(PLACE_SELECTED_CLASS);
			}
		});

		mmHighLightPlaceMarkerByCoordinates(coordinates);
	}

	function mmHighLightPlaceMarkerByCoordinates(coordinates) {
		const [lng, lat] = coordinates;
		const markers = document.querySelectorAll("#mm-map [data-marker-place-coordinates]");

		markers.forEach((marker) => {
			const [markerLng, markerLat] = JSON.parse(marker.dataset.markerPlaceCoordinates);
			const markerPath = marker.querySelector("path");

			if (markerLng === lng && markerLat === lat) {
				markerPath.setAttribute("fill", MARKER_SELECTED_COLOR);
			} else {
				markerPath.setAttribute("fill", MARKER_DEFAULT_COLOR);
			}
		});
	}

	function mmInitMap() {
		const map = new mapboxgl.Map({
			container: "mm-map", // container ID
			style: "mapbox://styles/mapbox/streets-v12", // style URL
			center: [2.25, 46.45], // starting position [lng, lat]
			zoom: 4, // starting zoom
		});

		window.mmMap = map;

		// Add geocoded search
		const geocoder = new MapboxGeocoder({
			mapboxgl: mapboxgl,
			accessToken: mapboxgl.accessToken,
			countries: "de,au,ie,ca,gb,ch,se,ae,jp,qa,it,fr,gf", // comma separated list
		});

		geocoderWrapper.appendChild(geocoder.onAdd(map));

		// Add geolocate control to the map.
		map.addControl(
			new mapboxgl.GeolocateControl({
				positionOptions: {
					enableHighAccuracy: true,
				},
				// When active the map will receive updates to the device's location as it changes.
				trackUserLocation: true,
				// Draw an arrow next to the location dot to indicate which direction the device is heading.
				showUserHeading: true,
			})
		);

		places.forEach((place) => {
			const marker = new mapboxgl.Marker().setLngLat(place.coordinates).addTo(map);
			const markerElement = marker.getElement();

			markerElement.dataset.markerPlaceCoordinates = JSON.stringify(place.coordinates);

			markerElement.addEventListener("click", () => {
				mmFlyToPlaceByCoordinates(place.coordinates);
			});
		});

		// Display visible markers initially
		mmDisplayVisibleMarkers(map);

		map.on("moveend", (event) => {
			// Nous n'avons plus besoin de vider placesContainer ici car mmDisplayVisibleMarkers le fait déjà

			// Afficher les marqueurs visibles quelle que soit la valeur du zoom
			mmDisplayVisibleMarkers(map);

			// if move was triggered by mmFlyToPlaceByCoordinates, highlight card in list
			if (event.placeCoordinatesToSelect) {
				mmSelectPlaceByCoordinates(event.placeCoordinatesToSelect);
			}
		});

		placesContainer.addEventListener("click", (event) => {
			const target = event.target;

			// Trouver la carte la plus proche sur laquelle on a cliqué
			const card = target.closest(".mm-map-place-card");
			if (!card) return; // Si on n'a pas cliqué sur une carte, ne rien faire

			const coordinates = JSON.parse(card.dataset.placeCoordinates);
			mmFlyToPlaceByCoordinates(coordinates);
		});
	}
}

document.addEventListener("DOMContentLoaded", mmInitMap);
